(() => {
  'use strict';
  // Native details keeps navigation fully usable without JavaScript.
  function initializeHome(scope) {
    scope.querySelectorAll('.nh-mobile-menu').forEach((menu) => {
      if (menu.dataset.nhReady) return;
      menu.dataset.nhReady = 'true';
      const trigger = menu.querySelector('summary');
      menu.addEventListener('toggle', () => {
        trigger.setAttribute('aria-label', menu.open ? 'Close navigation menu' : 'Open navigation menu');
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false;
          trigger.focus();
          event.preventDefault();
        }
      });
      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => { menu.open = false; });
      });
      menu.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!menu.contains(document.activeElement)) menu.open = false;
        });
      });
    });
  }
  initializeHome(document);
  document.addEventListener('shopify:section:load', (event) => initializeHome(event.target));
})();
